<app-document-table
  [subtitle]="rootFolderName() ? 'Indice: ' + rootFolderName() : 'Gestione documenti processati'"
  [basePath]="targetIndex() ? 'processed/' + targetIndex() + '/' : 'processed/'" 
  [documents]="documents()"
  [isLoading]="isLoading()"
  [loadingMessage]="loadingMessage()"
  [hasError]="hasError()">
</app-document-table>